import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import {
  addressesTranslationEN,
  announcementsPageTranslationEN,
  auditLogsEN,
  businessGroupsTranslationEN,
  buyNumbersTranslationEN,
  callFlowDetailsTranslationEN,
  callFlowItemsTranslationEN,
  callFlowListTranslationEN,
  callLogsTranslationEN,
  callReportsTranslationEN,
  commonTranslationEN,
  countriesEN,
  countryRestrictionsTranslationEN,
  customerSettingsTranslationEN,
  deliveryGroupsTranslationEN,
  destinationTranslationEN,
  globalConfigPageTranslationEN,
  inboundNumbersTranslationEN,
  numberProvisionTranslationEN,
  regulatoryBundleTranslationEN,
  requestNumbersTranslationEN,
  variablesTranslationEN,
  sipTrunkTranslationEN,
} from "src/localization";

export const resources = {
  en: {
    addresses: addressesTranslationEN,
    announcements: announcementsPageTranslationEN,
    auditLogs: auditLogsEN,
    businessGroups: businessGroupsTranslationEN,
    buyNumbers: buyNumbersTranslationEN,
    callFlowDetails: callFlowDetailsTranslationEN,
    callFlowItems: callFlowItemsTranslationEN,
    callFlowList: callFlowListTranslationEN,
    callLogs: callLogsTranslationEN,
    callReports: callReportsTranslationEN,
    common: commonTranslationEN,
    countries: countriesEN,
    countryRestrictions: countryRestrictionsTranslationEN,
    customerSettings: customerSettingsTranslationEN,
    deliveryGroups: deliveryGroupsTranslationEN,
    destinationNumbers: destinationTranslationEN,
    globalConfigPage: globalConfigPageTranslationEN,
    inboundNumbers: inboundNumbersTranslationEN,
    numberProvision: numberProvisionTranslationEN,
    regulatoryBundle: regulatoryBundleTranslationEN,
    requestNumbers: requestNumbersTranslationEN,
    variables: variablesTranslationEN,
    sipTrunk: sipTrunkTranslationEN,
  },
};

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    defaultNS: "common",
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
